import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CorrespondenceService } from '../../../domain/services/correspondence/correspondence.service';
import { BreadcrumbService } from '../../../domain/services/breadcrumb/breadcrumb.service';
import { CorrespondenceAlert } from '../../../domain/models/correspondence.model';

@Component({
  selector: 'app-alerts-list',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    MatCardModule,
    MatDividerModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './alerts-list.component.html',
  styleUrl: './alerts-list.component.css'
})
export class AlertsListComponent implements OnInit {
  alerts: CorrespondenceAlert[] = [];
  loading = true;

  constructor(
    private readonly correspondenceService: CorrespondenceService,
    private readonly breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.updateBreadcrumbs([
      { icon: 'mail', url: '/app/correspondence/emails', label: 'Correspondence' },
      { icon: '', url: '/app/correspondence/alerts', label: 'Alerts' }
    ]);

    this.correspondenceService.getAlerts().subscribe(alerts => {
      this.alerts = alerts;
      this.loading = false;
    });
  }

  onToggleAlert(alert: CorrespondenceAlert, enabled: boolean): void {
    this.correspondenceService.toggleAlertEnabled(alert.id, enabled).subscribe(updated => {
      const idx = this.alerts.findIndex(a => a.id === updated.id);
      if (idx !== -1) {
        this.alerts[idx] = updated;
      }
    });
  }

  get enabledCount(): number {
    return this.alerts.filter(a => a.enabled).length;
  }
}
